module.exports = __webpack_public_path__ + "img/vertical_3_7_4.29ec2bbd.png";